module.exports = __webpack_public_path__ + "img/e106bae182702082cb0960c012e96e39.png";